import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PreviewHeader from "../components/PreviewHeader";
import "../styles/previewPage.css";

export default function PreviewPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [url, setUrl] = useState("");

  useEffect(() => {
    const finalUrl =
      location.state?.previewUrl ||
      sessionStorage.getItem("previewUrl");

    if (!finalUrl) {
      navigate("/", { replace: true });
    }

    setUrl(finalUrl);
  }, [location, navigate]);

  return (
    <div className="preview-page-wrapper">
      <div className="preview-iframe-container">
        {url ? (
          <iframe
            src={url}
            className="preview-iframe"
            title="siteplus-preview"
          />
        ) : (
          <div className="preview-loading">
            Loading preview…
          </div>
        )}
      </div>
    </div>
  );
}
